/** Открытые окна в порядке открытия: порядок в top layer тот же, последнее лежит сверху. */
const openDialogs = new Set<HTMLDialogElement>();

const OVERLAY_GUESTS = '.c-toast-container, [data-overlay-guest]';

const topDialog = (): HTMLDialogElement | undefined => [...openDialogs].at(-1);

/**
 * Всё вне верхнего окна браузер делает неактивным, а z-index не поднимет элемент над top layer,
 * поэтому тосты и dev-пульт ККМ кочуют в верхнее окно, а без окон возвращаются в `body`.
 */
export const syncOverlayGuests = (): void => {
  const target = topDialog() ?? document.body;

  for (const guest of document.querySelectorAll(OVERLAY_GUESTS)) {
    if (guest.parentElement !== target) target.append(guest);
  }
};

export const pushDialog = (dialog: HTMLDialogElement): void => {
  openDialogs.add(dialog);
  syncOverlayGuests();
};

export const removeDialog = (dialog: HTMLDialogElement): void => {
  openDialogs.delete(dialog);
  syncOverlayGuests();
};

export const isTopDialog = (dialog: HTMLDialogElement): boolean => topDialog() === dialog;

export const hasOpenDialog = (): boolean => openDialogs.size > 0;
